import { Typography, TypographyProps } from "@mui/material";
import { getFormattedDateBlogCard } from "../../../lib/blog";
import { RootState } from "../../../redux/store";
import { useSelector } from "react-redux";

type BlogCardBottomDateProps = { date?: string } & TypographyProps;

export const BlogCardBottomDate = ({
  date,
  sx,
  ...props
}: BlogCardBottomDateProps) => {
  const formattedDate = getFormattedDateBlogCard({ date: date });
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <Typography
      sx={{
        fontSize: "0.875",
        color: colors.surface.onSurface,
        "@media (min-width: 1240px)": {
          color: colors.surface.onSurfaceVariant,
        },
        ...sx,
      }}
      {...props}
    >
      {formattedDate}
    </Typography>
  );
};
